import Styled from './RadioStatCard.styled';

const RING_SIZE_PX = 60;
const RING_CENTER = 30;
const RING_RADIUS = 28;
const RING_STROKE = 4;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;

interface Props {
  percentage: number;
  index: string;
  label: string;
}

function RadioStatCard({ percentage, index, label }: Props) {
  const clampedPercentage = Math.min(100, Math.max(0, percentage));
  const progressOffset =
    RING_CIRCUMFERENCE * (1 - clampedPercentage / 100);

  return (
    <Styled.Root>
      <Styled.Ring>
        <Styled.RingSvg
          aria-hidden
          fill="none"
          height={RING_SIZE_PX}
          viewBox={`0 0 ${RING_SIZE_PX} ${RING_SIZE_PX}`}
          width={RING_SIZE_PX}>
          <Styled.RingTrack
            cx={RING_CENTER}
            cy={RING_CENTER}
            r={RING_RADIUS}
            strokeWidth={RING_STROKE}
          />
          <Styled.RingProgress
            cx={RING_CENTER}
            cy={RING_CENTER}
            r={RING_RADIUS}
            strokeDasharray={RING_CIRCUMFERENCE}
            strokeDashoffset={progressOffset}
            strokeWidth={RING_STROKE}
            transform={`rotate(-90 ${RING_CENTER} ${RING_CENTER})`}
          />
        </Styled.RingSvg>
        <Styled.RingContent>
          <Styled.Percentage>{Math.round(clampedPercentage)}%</Styled.Percentage>
          <Styled.Index>{index}</Styled.Index>
        </Styled.RingContent>
      </Styled.Ring>
      <Styled.Label>{label}</Styled.Label>
    </Styled.Root>
  );
}

export default RadioStatCard;
